export interface Uniforms {
  buffer: GPUBuffer;
  bindGroupLayout: GPUBindGroupLayout;
}

// Uniform layout: [time, resX, resY, frame] — 16 bytes (4 x f32)
export const UNIFORM_SIZE = 16;

export function createUniforms(device: GPUDevice): Uniforms {
  const buffer = device.createBuffer({
    size: UNIFORM_SIZE,
    usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
  });

  const bindGroupLayout = device.createBindGroupLayout({
    entries: [
      {
        binding: 0,
        visibility: GPUShaderStage.FRAGMENT,
        buffer: { type: 'uniform' },
      },
    ],
  });

  return { buffer, bindGroupLayout };
}
